import { render, staticRenderFns } from "./GoodsAuditForm.vue?vue&type=template&id=2b346ba6&scoped=true"
import script from "./GoodsAuditForm.vue?vue&type=script&lang=js"
export * from "./GoodsAuditForm.vue?vue&type=script&lang=js"
import style0 from "./GoodsAuditForm.vue?vue&type=style&index=0&id=2b346ba6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b346ba6",
  null
  
)

export default component.exports